module.exports = __webpack_public_path__ + "img/touKui6.1fd036c1.png";